<div
  class="bb-logo"
  aria-hidden="true"
  [ngClass]="{
    'bb-logo--emblem': isEmblem,
    'bb-logo--inverse': isInverse
  }"
></div>
